<template>
  <div class="container-fluid vh-100">
        <div class="row h-100">
            <!-- Coluna da Esquerda - Imagem/Logo -->
            <div class="col-md-6 d-none d-md-flex lc3-background-primary align-items-center justify-content-center">
                <div class="text-center text-white">
                    <img src="@/assets/logo.png" alt="Logo Toqe.net" class="img-logo mb-4">
                </div>
            </div>

            <!-- Coluna da Direita - Formulário -->
            <div class="col-md-6 d-flex align-items-center justify-content-center">
                <div class="w-100" style="max-width: 400px;">
                    <!-- Card de Login -->
                    <div class="card shadow-lg border-0">
                        <div class="card-header lc3-background-primary text-white text-center py-4">
                            <h2 class="card-title mb-0">
                                <i class="bi bi-person-circle me-2"></i>
                                Login
                            </h2>
                        </div>
                        
                        <div class="card-body p-4">
                            <!-- Formulário -->

                                <!-- Email -->
                                <div class="mb-3">
                                    <label for="email" class="form-label">
                                        <i class="bi bi-envelope me-2"></i>Email
                                    </label>
                                    <div class="input-group">
                                        <span class="input-group-text">
                                            <i class="bi bi-envelope"></i>
                                        </span>
                                        <input 
                                            type="email" 
                                            class="form-control" 
                                            v-model="user.email"
                                            id="email" 
                                            placeholder="seu@email.com"
                                            required
                                        >
                                    </div>
                                </div>

                                <!-- Senha -->
                                <div class="mb-3">
                                    <label for="password" class="form-label">
                                        <i class="bi bi-lock me-2"></i>Senha
                                    </label>
                                    <div class="input-group">
                                        <span class="input-group-text">
                                            <i class="bi bi-lock"></i>
                                        </span>
                                        <input 
                                            :type="showPassword ? 'text' : 'password'" 
                                            class="form-control" 
                                            id="password" 
                                            v-model="user.password"
                                            placeholder="Sua senha"
                                            required
                                        >
                                        <button 
                                            class="btn btn-outline-secondary" 
                                            type="button"
                                            @click="togglePassword"
                                            :aria-label="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
                                        >
                                            <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                                        </button>
                                    </div>
                                </div>

                                <!-- Botão de Login -->
                                <div class="d-grid mb-3">
                                    <button @click="login" class="btn lc3-btn-primary btn-lg">
                                        <span v-show="!loading">
                                            <i class="bi bi-box-arrow-in-right me-2"></i>Entrar
                                        </span>
                                        <div v-show="loading" class="spinner-border text-light" role="status">
                                            <span class="visually-hidden"></span>
                                        </div>
                                    </button>
                                </div>

                        </div>
                    </div>

                    <!-- Rodapé -->
                    <div class="text-center mt-3">
                        <p class="text-muted small">
                            Desenvolvido pela Equipe LC3 Digital.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/services/http.js';
import { reactive, ref } from 'vue';
import { useAuth } from '@/services/auth.js';
import router from '@/router';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';

export default {
  name: 'Login',
  setup() {
    const auth = useAuth();
    const toastStore = useToastStore();
    const showModal = ref(false);
    const showPassword = ref(false);

    var loading = ref(false);

    const user = reactive({
      email: '',
      password: ''
    });

    const togglePassword = () => {
      showPassword.value = !showPassword.value;
    };

    const register = async () => {
      try {
        loading.value = true;
        const now = Date.now();
        const { data } = await http.post('/register', user);
        auth.setToken(data.token);
        auth.setUser(JSON.stringify(data.user));
        if (data.tenant) {
          auth.setTenant(JSON.stringify(data.tenant));
        }
        auth.setLastVerification(now);
        toastStore.success('Cadastro realizado com sucesso!');
        router.push({ name: 'painel' });
      } catch (e) {
        loading.value = false;
        toastStore.error('Erro ao realizar cadastro: ' + parseError(e));
      }
    };

    const login = async () => {
      try {
        loading.value = true;
        const now = Date.now();
        const { data } = await http.post('/login', user);
        auth.setToken(data.token);
        auth.setUser(JSON.stringify(data.user));
        if (data.tenant) {
          auth.setTenant(JSON.stringify(data.tenant));
        }
        auth.setLastVerification(now);
        toastStore.success('Bem-vindo ao AlugUp!');
        router.push({ name: 'painel' });
      } catch (e) {
        loading.value = false;
        toastStore.error('Erro ao entrar: ' + parseError(e));
      }
    };

    return { user, login, showModal, loading, showPassword, togglePassword };
  }
};
</script>

<style scoped>
.lc3-painel {
  min-height: 100vh;
  max-height: 100vh;
}

.cardlogin {
  background-color: white;
}

.img-logo {
  width: 250px;
}
</style>